'use strict';

function useMin(isDebug) {
  return isDebug ? '' : '.min';
}

module.exports = useMin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/lib/use-min.js
// module id = 73
// module chunks = 0